import _ from 'lodash';

const DEFAULT_LANGUAGE = 'en_US';

function getDisplayKeys(locale) {
    return require(`translationsDisplayKeysPath/${locale}.json`);
}
class Translator {

    constructor(currentLocale) {
        this.setCurrentLocale(currentLocale);
        this.translateDisplayKey = this.translateDisplayKey.bind(this);
        this.translateDisplayKeyWithFallback = this.translateDisplayKeyWithFallback.bind(this);
        this.setCurrentLocale = this.setCurrentLocale.bind(this);
        this.memoizedGetDisplayKeys = _.memoize(getDisplayKeys);
    }

    setCurrentLocale(locale) {
        this.currentlocale = locale;
    }

    /**
     * Translates the l10n key if provided in the resources, otherwise returns the 'displaykey not found'
     *
     * @param {String} key - display key to be translated
     * @returns {string} translated message or 'displaykey not found'
     */
    translateDisplayKey(key) {
        if (this.memoizedGetDisplayKeys(this.currentlocale).hasOwnProperty(key)) {
            return this.memoizedGetDisplayKeys(this.currentlocale)[key];
        }
        return 'displaykey not found';
    }

    /**
     * Translates the l10n key if provided in the resources, otherwise returns the key
     * (applies the string interpolation if needed)
     * Sourced/cloned from edge\policycommon\common\models\CovTerm.js
     *
     * @param {String} key - display key to look up
     * @param {Object} [args] - optional arguments to apply to the display key
     * @returns {String} translated message or the key
     */
    translateDisplayKeyWithFallback(key, ...args) {
        if (!this.memoizedGetDisplayKeys(this.currentlocale).hasOwnProperty(key)) {
            return key;
        }
        let result = this.memoizedGetDisplayKeys(this.currentlocale)[key];

        if (args.length) {
            args.forEach((value, index) => {
                if (_.isObject(value)) {
                    _.keys(value).forEach(valueKey => {
                        result = result.replace(`{{${valueKey}}}`, value[valueKey]);
                    });
                } else {
                    result = result.replace(`{{_${index}}}`, value);
                }
            });
        }
        return result;
    }
}

const defaultTranslator = new Translator(DEFAULT_LANGUAGE);
const translateDisplayKey = defaultTranslator.translateDisplayKey;
const translateDisplayKeyWithFallback = defaultTranslator.translateDisplayKeyWithFallback;
const setCurrentLocale = defaultTranslator.setCurrentLocale;

export {
    Translator,
    translateDisplayKey,
    translateDisplayKeyWithFallback,
    setCurrentLocale
};
